<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">用户管理</div>
      <div class="content-item">
        <OrganizationTree ref="organizationTreeRef" @nodeClick="nodeClick" showBtn></OrganizationTree>
        <div class="content-right">
          <div class="right-title">人员</div>
          <div class="query">
            <MyForm
              class="search-form"
              :formOptions="queryForm"
              :inline="true"
            ></MyForm>
            <div class="query-btn">
              <MyButton icon="Plus" @click="addUnit">添加组织</MyButton>
              <MyButton icon="Plus" @click="addUser">添加用户</MyButton>
            </div>
          </div>
          <div class="table">
            <MyTable :table-options="tableOptions" border max-height="60vh">
              <template #sex="{ row }">
                <span v-if="row.sex == 1">男</span>
                <span v-if="row.sex == 2">女</span>
              </template>
              <template #handler="{ row }">
                <MyButton link icon="View" @click="click_Row_view(row)">查看</MyButton>
                <MyButton link icon="Edit" @click="click_Row_Edit(row)" v-auth="(val) => val<=0">编辑</MyButton>
                <ConfirmButton hint="确定要移除吗" link icon="Delete" @confirm="click_Row_delete(row)" v-auth="(val) => val<=0">移除</ConfirmButton>
              </template>
            </MyTable>
          </div>
        </div>
      </div>
      <MyPagination :params="paginationParams" :total="total" @get-list="getUserList" ref="paginationRef" />
    </div>

    <!-- 新增组织 -->
    <Dialog width="30%" v-model="dialogAddUnitVisible" title="新增组织" top="5vh" @closed="addUnitForm.name = ''">
      <el-form style="margin-bottom: 30px;padding: 0 50px;">
        <el-form-item label="组织名称:">
          <el-input v-model="addUnitForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div class="submit-buttons">
        <el-button @click="dialogAddUnitVisible = false">取消</el-button>
        <el-button @click="addUnit_confirm">确定</el-button>
      </div>
    </Dialog>
    
    <!-- 添加用户 -->
    <Dialog
      width="50%"
      v-model="dialogAddUserVisible"
      title="添加用户"
      top="5vh"
    >
      <MyForm
        class="add-user-form"
        :formOptions="addUserForm"
        :inline="true"
        ref="myFormRef"
        label-width="auto"
      ></MyForm>
      <div class="submit-buttons">
        <el-button @click="dialogAddUserVisible = false">取消</el-button>
        <el-button @click="click_addUser_confirm">确定</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import Dialog from "@/components/Common/Dialog.vue";
import MyTable from "@/components/Global/MyTable.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import OrganizationTree from "@/components/Common/OrganizationTree.vue";
import { ref, reactive, computed, provide, nextTick } from "vue";
import organizationApi from "@/api/organization";
import { ElMessage } from "element-plus";
import dictionary from "@/api/dict.js";
import roleApi from "@/api/role";

//搜索
const queryForm = reactive({
  itemList: [
    {
      type: "input",
      label: "关键词:",
      prop: "Name",
      attrs: {
        placeholder: "请输入关键词",
      },
    },
    [
      {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
        },
        events: {
          click(formData) {
            Object.assign(paginationParams, formData);
          },
        },
      },
      {
        type: "Button",
        value: "重置",
        attrs: {
          icon: "Refresh",
        },
        events: {
          click(formData) {
            formData.Name = "";
            Object.assign(paginationParams, formData);
          },
        },
      },
    ]
  ],
});

const tableOptions = reactive({
  colList: [
    { label: "序号", type: "index", minWidth: 60 },
    { label: "职位", prop: "dictDataName" },
    { label: "姓名", prop: "userName" },
    { label: "电话", prop: "phone" },
    { label: "性别", prop: "sex", type: "slot", slot_name: "sex" },
    { label: "邮箱", prop: "email", },
    { label: "操作", type: "slot", slot_name: "handler", minWidth: 150 },
  ],
  tableData: [],
});

const currentUnit = ref({});
const nodeClick = (data) => {
  currentUnit.value = data;
  paginationParams.OrganizationId = data.id;
}
// 分页
const paginationParams = reactive({
  OrganizationId: "",
  Type: 1,
})
const paginationRef = ref(null);
const total = ref(0);
const getUserList = (params = paginationRef.value.getList_params) => {
  if(!params.OrganizationId){
    return;
  }
  organizationApi.getUserList(params).then((res) => {
    total.value = res.data.totalCount;
    tableOptions.tableData = res.data.items;
  })
}

// 添加用户
//职位列表
const dictList = ref([]);
const getDictList = () => {
  dictionary.getList('OrganizationTitle').then((res) => {
    dictList.value = res.data.items.map(item=>{
      return {
        label: item.name,
        value: item.id,
        ...item
      }
    });
  })
}
getDictList();
//部门列表
const departmentList = ref([]);
const getDepartmentList = () => {
  organizationApi.getDepartmentList({
    SkipCount: 0,
    MaxResultCount: 1000,
  }).then((res) => {
    departmentList.value = res.data.items.map(item=>{
      return {
        label: item.name,
        value: item.name,
        ...item
      }
    });
  })
}
getDepartmentList();
//角色列表
const roleList = ref([]);
const getRoleList = () => {
  roleApi.getRoleList({
    SkipCount: 0,
    MaxResultCount: 1000,
    RoleType: 1
  }).then((res) => {
    roleList.value = res.data.items.map(item=>{
      return {
        label: item.roleName,
        value: item.id,
        ...item
      }
    });
  })
}
getRoleList();

const itemList = computed(() => {
  const base = [
    {
      type: "Input",
      label: "姓名：",
      prop: "userName",
    },
    {
      type: "Radio",
      label: "性别：",
      prop: "sex",
      defaultValue: 1,
      options: [
        { label: "男", value: 1 },
        { label: "女", value: 2 },
      ],
    },
    {
      type: "Input",
      label: "账号：",
      prop: "loginUser",
    },
    {
      type: "Date",
      label: "出生日期：",
      prop: "birth",
      attrs: {
        valueFormat: "YYYY-MM-DD",
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        }
      },
    },
    {
      type: "Input",
      label: "密码：",
      prop: "password",
    },
    {
      type: "Input",
      label: "电话：",
      prop: "phone",
    },
    {
      type: "Input",
      label: "所属组织：",
      prop: "organizationName",
      attrs: {
        readonly: true,
      },
    },
    {
      type: "Input",
      label: "电子邮箱：",
      prop: "email",
    },
    {
      type: "Select",
      label: "所属部门：",
      prop: "departmentName",
      options: departmentList,
    },
    {
      type: "Select",
      label: "角色：",
      prop: "roleId",
      options: roleList,
    },
    {
      type: "Select",
      label: "职位：",
      prop: "dictDataId",
      options: dictList,
      events: {
        change(formData) {
          if(!formData.dictDataId) return;
          formData.dictDataName = dictList.value.find((item) => item.id === formData.dictDataId).name;
        },
      }
    },
  ];
  if (Flag.value === 0) {
    base.splice(4, 1, {
      type: "Input",
      label: "密码",
      prop: "password",
    });
  } else {
    base.splice(4, 1, {
      type: "Input",
      label: "密码",
      prop: "_password",
      defaultValue: "**********",
      attrs: {
        readonly: true,
      },
    });
  }
  return base;
});
const Flag = ref(0);
const readonly = computed(() => Flag.value === 2); //只读
const addUserForm = reactive({
  itemList: itemList,
  rules: {
    userName: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
    loginUser: [{ required: true, message: "账号不能为空", trigger: "blur" }],
    password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
    phone: [
      // { required: true, message: "手机号不能为空", trigger: "blur" },
      { pattern: /^1\d{10}$/, message: "手机号格式不正确", trigger: "blur" },
    ],
  },
  commonAttrs: {
    readonly,
  },
});

//添加子组织
const dialogAddUnitVisible = ref(false);
const addUnitForm = reactive({
  name: "",
})
const addUnit = () => {
  if(!currentUnit.value?.id){
    return ElMessage.warning("请先选择组织");
  }
  addUnitForm.parentId = currentUnit.value.id;
  addUnitForm.type = currentUnit.value.type;
  addUnitForm.isTesterAdd = currentUnit.value.isTesterAdd;
  dialogAddUnitVisible.value = true;
}
const organizationTreeRef = ref(null);
const addUnit_confirm = () => {
  if(!addUnitForm.name){
    return ElMessage.warning("请输入组织名称");
  }
  organizationApi.addUnit(addUnitForm).then((res) => {
    ElMessage.success("新增成功");
    res.data.leaf = true;
    organizationTreeRef.value.treeRef.append(res.data, addUnitForm.parentId);
    dialogAddUnitVisible.value = false;
  })
};

// 打开添加用户模态框
const dialogAddUserVisible = ref(false);
const addUser = async() => {
  if(!currentUnit.value?.id){
    return ElMessage.warning("请先选择组织");
  }
  Flag.value = 0;
  dialogAddUserVisible.value = true;
  await nextTick();
  const { formData } = myFormRef.value;
  formData.organizationName = currentUnit.value.name;
};
// 添加用户确认
const myFormRef = ref(null);
const click_addUser_confirm = () => {
  if (Flag.value === 2) return (dialogAddUserVisible.value = false); //查看用户
  const { formRef, formData } = myFormRef.value;
  console.log(" formData:", formData)

  formRef.validate(async(valid) => {
    if (valid) {
      formData.organizationId = currentUnit.value.id;
      formData.type = 1;
      let res = formData.id ? await organizationApi.editUser(formData)
      : await organizationApi.addUser(formData);
      formData.roleBindId ? await roleApi.bindUserEdit({
        id: formData.roleBindId,
        userId: res.data.id,
        roleId: formData.roleId,
      }) : await roleApi.bindUser({
        userId: res.data.id,
        roleId: formData.roleId,
      });
      ElMessage.success("操作成功");
      dialogAddUserVisible.value = false;
      getUserList();
    }
  })
};

// 获取用户拥有的角色列表
const getUserRoles = async (userId) => {
  let res = await roleApi.getUserRoles({
    UserId: userId,
    SkipCount: 0,
    MaxResultCount: 1000,
  });
  const { items } = res.data;
  return items;
};

const click_Row_view = async(row) => {
  Flag.value = 2;
  dialogAddUserVisible.value = true;
  await nextTick();
  const { formData } = myFormRef.value;
  Object.assign(formData, row);
}
const click_Row_Edit = async(row) => {
  Flag.value = 1;
  dialogAddUserVisible.value = true;
  await nextTick();
  const { formData } = myFormRef.value;
  let res = await getUserRoles(row.id)
  if(res.length){
    formData.roleBindId = res[0].id;
  }
  Object.assign(formData, row);
}
const click_Row_delete = (row) => {
  organizationApi.delUser(row.id).then((res) => {
    ElMessage.success("移除成功");
    getUserList();
  })
}
</script>

<style lang="scss" scoped>
.container {
  .container-content {
    .content-item {
      display: flex;
      min-height: 60vh;
      .content-right {
        flex: 1;
        overflow: hidden;
        .right-title {
          background: #134e92;
          height: 40px;
          line-height: 40px ;
          color: #66baec;
          display: flex;
          justify-content: space-between;
          padding-left: 20px;
        }
        .query {
          background: #03386a;
          padding: 0 20px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #66baec;
          .search-form {
            padding-top: 20px;
          }
        }
      }
    }
  }
}
.add-user-form {
  padding: 0 50px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  :deep(){
    .el-input,.el-select {
      width: 100%;
      height: 40px;
    }
    .el-select__wrapper{
      width: 100%;
      height: 100%;
    }
  }
}

</style>
